//deps
import * as React from "react";

//internal-deps
import {
    CheckoutActionTypes,
    CheckoutContext,
    CheckoutRoute,
    useNavigate,
    HardwareBackContext,
    closeWebview,
} from "@swiggy-private/checkout-core";
import { RouteContext } from "@swiggy-private/core-ui";

export function RouteContainer(props: { children: React.ReactElement | null }): React.ReactElement | null {
    const { checkoutState } = React.useContext(CheckoutContext);
    const navigateTo = useNavigate();
    const { route } = React.useContext(RouteContext);
    const { setState: setHardwareBackState } = React.useContext(HardwareBackContext);
    const type = checkoutState.type;

    const handleBack = React.useCallback(
        (event: PopStateEvent): void => {
            // if route is payment-modes-link-wallet-with-number, close the webview
            if (route?.name === CheckoutRoute.PAYMENT_MODES_LINK_WALLET_WITH_NUMBER) {
                closeWebview();
            }
            // handle scenario when user has linked the wallet and want to go back
            else if (
                route?.name === CheckoutRoute.PAYMENT_MODES_VERIFY_WALLET_LINK_OTP &&
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                !!(route?.data as any)?.stopNavigation
            ) {
                history.pushState({ name: route?.name, data: route?.data }, "", "");
                return;
            }
            // handle scenario when user has delinked the wallet or delinking the wallet and wants to go back
            else if (route?.name === CheckoutRoute.WALLET_DETAILS) {
                history.pushState({ name: CheckoutRoute.WALLET_DETAILS, data: route?.data }, "", "");
                setHardwareBackState({
                    shouldHandle: true,
                    activeRoute: route?.name,
                });
                return;
            }
            // handle scenario when user is on penny txn status poller page and want to go back
            else if (route?.name === CheckoutRoute.PENNY_TXN_STATUS_POLLER) {
                history.pushState({ name: CheckoutRoute.PENNY_TXN_STATUS_POLLER, data: route?.data }, "", "");
                setHardwareBackState({
                    shouldHandle: true,
                    activeRoute: route?.name,
                });
                return;
            }

            if (event.state && event.state.name) {
                navigateTo(event.state.name, event.state.data);
            }
        },
        [navigateTo, route, setHardwareBackState],
    );

    React.useEffect(() => {
        window.addEventListener("popstate", handleBack);

        return (): void => {
            window.removeEventListener("popstate", handleBack);
        };
    }, [handleBack]);

    React.useEffect(() => {
        /** if Checkout state if confirm transaction */
        if (type === CheckoutActionTypes.CONFIRM_TRANSACTION && route?.name !== CheckoutRoute.CONFIRM_TRANSACTION) {
            navigateTo(CheckoutRoute.CONFIRM_TRANSACTION);
        }

        if (
            type === CheckoutActionTypes.PENNY_TXN_STATUS_POLLER &&
            route?.name !== CheckoutRoute.PENNY_TXN_STATUS_POLLER
        ) {
            navigateTo(CheckoutRoute.PENNY_TXN_STATUS_POLLER);
        }

        if (type === CheckoutActionTypes.SHOW_FULL_PAGE_LOADER && route?.name !== CheckoutRoute.REDIRECT_PAGE) {
            navigateTo(CheckoutRoute.REDIRECT_PAGE);
        }
    }, [type, navigateTo, route]);

    return props.children;
}
